import { useInstantSearch } from 'react-instantsearch';
import * as React from 'react';

export type NoResultsBoundaryProps = {
  children?: React.ReactNode;
  fallback: React.ReactNode;
};

const NoResultsBoundary = ({ children, fallback }: NoResultsBoundaryProps) => {
  const { results, indexUiState } = useInstantSearch();

  // The `__isArtificial` flag makes sure not to display the No Results message
  // when no hits have been returned.
  // eslint-disable-next-line no-underscore-dangle
  if (!indexUiState.query || results.nbHits === 0) {
    return (
      <>
        {fallback}
        <div hidden>{children}</div>
      </>
    );
  }

  return <>{children}</>;
};

export default NoResultsBoundary;
